export default {
  AUTO: 'auto',
  RECREATIONAL: 'recreational',
};
